<template>
  <div>
    <!-- Loading... -->
  </div>
</template>
<script>
import { h } from 'vue';

export default {
  name: "loading-page",
  data() {
    return {
      loader: null
    }
  },
  created() {
    this.loader = this.$loading.show({},{
      after: () => h('div',{},`Retrieving application data...`)
    });
  },
  beforeDestroy() {
    this.loader.hide();
    this.loader = null;
  }
}
</script>